import { auth } from './../../firebase/utils';
import { takeLatest, put, all, call } from 'redux-saga/effects';
import { setUserInfoPage, fetchUsersStart, setUserInfo } from './userInfo.actions';
import { handleAddUserInfo,handleFetchUserInfo,
  handleFetchUserInfoPage } from './userInfo.helpers';
import  UserInfoType from './userInfo.types';

export function* addUserInfo({ payload: {
    name,
    phone,
    address,
    social
  }}) {
  
    try {
      const timestamp = new Date();
      yield handleAddUserInfo({
        name,
        phone,
        address,
        social,
        createdDate: timestamp,
        productAdminUserUID: auth.currentUser.uid,
      });
      yield put(
        fetchUsersStart()
      );
  
  
    } catch (err) {
      // console.log(err);
    }
  
  }
  
  export function* onAddUserInfoStart() {
    yield takeLatest(UserInfoType.ADD_USER_INFO, addUserInfo);
  }
  
  export function* fetchUserInfo() {
    try {
      const userInfos = yield handleFetchUserInfo();
      yield put(
        setUserInfo(userInfos)
      );
  
    } catch (err) {
      // console.log(err);
    }
  }
  
  
  export function* onFetchUserUnfosStart() {
    yield takeLatest(UserInfoType.FETCH_USER_INFO, fetchUserInfo);
  }
  

  export function* fetchUser({ payload }) {
    try {
      const userInfo = yield handleFetchUserInfoPage(payload);
      yield put(
        setUserInfoPage(userInfo)
      );
  
    } catch (err) {
      // console.log(err);
    }
  }
  export function* onFetchUsertart() {
    yield takeLatest(UserInfoType.FETCH_USERPAGE_INFO, fetchUser);
  }

  export default function* userInfoSagas() {
    yield all([
      call(onAddUserInfoStart),
      call(onFetchUserUnfosStart),
      call(onFetchUsertart),
    ])
  } 